import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef, Renderer2, Inject, Optional } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { saveAs } from 'file-saver';
import { TranscriptService } from 'src/app/services/transcript.service';
import { ProgressBarEvent } from 'ngx-extended-pdf-viewer';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';



@Component({
    selector: 'app-pdf-view',
    templateUrl: './pdf-view.component.html',
    styleUrls: ['./pdf-view.component.scss'],
    standalone: false
})
export class PdfViewComponent implements OnInit {
  bearerToken: string;
  apiUrl: any;
  fileURL: string;
  sourceObject: { url: string; httpHeaders: { Authorization: string; }; } | undefined;
  zoom = 'page-width'; // Default zoom level
  zoomStepSize = 10;
  private _transcriptId: number | undefined;
  private _soeScanId: number | undefined;
  private _token: any;
  windowResizing: boolean;
  zoomLevelBeforeWindowResize: number;
  downloadProgress: number = 0;
  displayLoadingErrorMessage: boolean;
  srcURL: string;
  headers: { Authorization: string; };
  downloadProgressDisplay: string;
  @Input() height: string = "auto";

  @Output() downloadComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() widthResized: EventEmitter<number> = new EventEmitter<number>();
  @Input() set transcriptID(id: number) {
    this._transcriptId = id;
  }
  @Input() set scannedSOEId(id: number) {
    this._soeScanId = id;
  }
  @ViewChild(PdfViewComponent) pdfView: PdfViewComponent;
  @ViewChild('pdfViewerContainer', { static: true }) pdfViewer: ElementRef;

  private resizing = false;
  private startingCoordinateOnX_axis: number;
  private startWidth: number;


  startResize(event: MouseEvent) {
    this.resizing = true;
    this.startingCoordinateOnX_axis = event.clientX;
    this.startWidth = this.pdfViewer.nativeElement.offsetWidth;

    this.renderer.listen('window', 'mousemove', this.onResize);
    this.renderer.listen('window', 'mouseup', this.stopResize);
    event.preventDefault();
  }

  onResize = (event: MouseEvent) => {
    if (!this.resizing) return;
    const differenceBetweenBorderStartingPositionAndCurrentPosition = event.clientX - this.startingCoordinateOnX_axis;
    let newWidth = this.startWidth + differenceBetweenBorderStartingPositionAndCurrentPosition;
    newWidth = Math.max(300, Math.min(newWidth, window.innerWidth * 0.9));
    this.pdfViewer.nativeElement.style.width = `${newWidth}px`;
    this.widthResized.emit(newWidth);
  };

  stopResize = () => {
    if (this.resizing) {
      this.resizing = false;
      this.refreshPdfViewer(); // Call your refresh function here
    }
  };



  get transcriptID(): number {
    return this._transcriptId;
  }

  get soeScanId(): number {
    return this._soeScanId;
  }

  constructor(
    private configSvc: ConfigService,
    private authService: AuthService,
    private transcriptService: TranscriptService,
    private renderer: Renderer2,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Blob
  ) {
    this.apiUrl = this.configSvc.getApiUrl();
    if(data){
      this.srcURL = URL.createObjectURL(data);
    }
   }

  ngOnInit() {
    if (this.transcriptID){
      this.buildTranscriptPdfSourceObject(this.transcriptID);
    }
    if (this.soeScanId){
      this.buildSoeScanPdfSourceObject(this.soeScanId);
    }
    if (this.pdfView) {
      this.pdfView.setPageWidthView();
    }
  }

  get progressBarMode(): string {
    return this.downloadProgress === 0 ? 'indeterminate': 'determinate' ;
  }

  async buildTranscriptPdfSourceObject(id: number) {
    const url = `${this.apiUrl}/transcript/${id}?type=pdf`;
    let token = '';
    this.srcURL = url;
    await this.getToken().then(tokenResult => {
      token = tokenResult;
      const authorization = `Bearer ${token}`;
      this.headers = { Authorization: authorization };
      this.sourceObject = {
        url: url,
        httpHeaders: { Authorization: authorization }
      };
    });
  }

  async buildSoeScanPdfSourceObject(id: number) {
    const url = `${this.apiUrl}/soe-scans/${id}?type=pdf`;
    let token = '';
    this.srcURL = url;
    await this.getToken().then(tokenResult => {
      token = tokenResult;
      const authorization = `Bearer ${token}`;
      this.headers = { Authorization: authorization };
      this.sourceObject = {
        url: url,
        httpHeaders: { Authorization: authorization }
      };
    });
  }

  async getToken() {
    if (!this._token){
      let result = await this.authService.getAccessTokenForAPI().then(token => {
        this._token = token;
        return token;
      });
      return result;
    }
    else {
      return this._token;
    }
  }


  onDownloadProgress(progressData: ProgressBarEvent ): void {
    this.downloadProgress = progressData.percent;
    this.downloadProgressDisplay = this.downloadProgress.toFixed(0);
    if (this.downloadProgress === 100) {
      this.downloadComplete.emit(null);
    }
  }

  onDownloadTranscript(): void {
    this.transcriptService.downloadTranscript(this._transcriptId).subscribe((blob)=>saveAs(blob, 'transcript.pdf'));
  }

  onLoadingError(error: Error) {
    console.error(error);
    this.displayLoadingErrorMessage = true;
  }

  setPageWidthView() {

    this.zoom = 'actual-size'; // or use the appropriate property for your PDF viewer
  }
  refreshPdfViewer() {
    console.log('Refreshing PDF viewer...');

    // this.pdfView.setPageWidthView();
    // Or call another refresh method if you have one
      // Set zoom to actual size first
    this.zoom = '100';

    // Then after a short delay, set zoom to page width
    setTimeout(() => {
      this.zoom = 'page-width';
      // this.pdfViewer.nativeElement.style.width = '100%'; // Ensure the width is set to 100% for page width view
    }, 200); // 200ms delay, adjust as needed
  }
}
